import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

import NowFaqModalContainer from '.'

export default ({ container, i18n }) => {
  hydrateWithHOCs({
    container,
    i18n,
  })(<NowFaqModalContainer />)
}
